<template>
  <!-- 产品详情页面 -->
  <div>
    <mrc_ess_skeleton_loader :loading="skLoading">
      <mrc_ess_iconGroup :is_disabled="disabled"
                         :showEdit="true"
                         :show_del="false"
                         @handleReturn="handleReturn"
                         @handleEdit="handleEdit"></mrc_ess_iconGroup>
      <v-card>
        <v-card-text>
          <div style="text-align:right">
            {{ uuid }}
          </div>
          <form ref="product_detail">
            <v-row>
              <!-- <v-col cols="12"
                   sm="6">
              <v-text-field :label="$t('label_The_product_name')+'*'"
                            :readonly="disabled"
                            v-model="detailData.product_name"
                            append-icon="mdi-longitude">
              </v-text-field>
            </v-col>
            <v-col cols="12"
                   sm="6">
              <v-text-field :label="$t('label_Product_short_code')+'*'"
                            :readonly="disabled"
                            v-model="detailData.product_shortcode"
                            append-icon="mdi-longitude">
              </v-text-field>
            </v-col> -->
              <v-col cols="12"
                     sm="6">
                <mrc_ess_multiText :label="$t('label_The_product_name') + '*'"
                                   :readonly="disabled"
                                   :isNational="judegNational('product_name')"
                                   v-model="detailData.product_name"
                                   append-icon="mdi-longitude">
                </mrc_ess_multiText>
              </v-col>
              <v-col cols="12"
                     sm="6">
                <mrc_ess_multiText :label="$t('label_Product_short_code') + '*'"
                                   :readonly="disabled"
                                   :isNational="judegNational('product_shortcode')"
                                   v-model="detailData.product_shortcode"
                                   append-icon="mdi-longitude">
                </mrc_ess_multiText>
              </v-col>
              <!-- <v-col cols="12"
                   sm="6">
              <v-select :items="version_arr"
                        item-value='value_field'
                        item-text='view_fields'
                        :label="$t('label_version')+'*'"
                        :readonly="disabled"
                        v-model="detailData.version"
                        chips></v-select>
            </v-col> -->
              <v-col cols="12"
                     sm="12">
                <!-- <mrc_ess_colorPicker v-model="color"
                                     :disabled="disabled"></mrc_ess_colorPicker> -->
                <mrc_ess_NumInput :readonly="disabled"
                                  :error-messages="
                    $errors(
                      'detailData',
                      'sequence',
                      between('000-999').concat(requiredRule)
                    )
                  "
                                  :label="$t('label_The_sorting') + '*'"
                                  v-model="detailData.sequence"></mrc_ess_NumInput>
                <!-- <mrc_ess_input
                  :label="$t('label_The_sorting') + '*'"
                  :readonly="disabled"
                  v-model.number="detailData.sequence"
                  :rules="$text_rules($t('verify_Required'))"
                >
                </mrc_ess_input> -->
              </v-col>
              <v-col cols="12"
                     sm="12">
                <mrc_ess_brandupload v-model="detailData.product_icon"
                                     :label="$t('label_imgIcon')"
                                     :disabled="disabled"
                                     @deleteicon="deleteicon"
                                     @changeimgSrc="changeimgSrc"></mrc_ess_brandupload>
              </v-col>
            </v-row>
          </form>
        </v-card-text>
      </v-card>
      <mrc_ess_submitBtn v-show="!disabled"
                         @cancel="cancel"
                         @success="success"></mrc_ess_submitBtn>
      <!-- -->
      <confirm :isOpen="isOpen"
               @onCancel="onCancel"
               :showText="showText"
               @onConfirm="onConfirm"
               :isLoading="isLoading" />
    </mrc_ess_skeleton_loader>
  </div>
</template>

<script>
import { getBusinessList } from '@/service/api/func_module'
import { get_detail, get_update } from '@/service/api/product'
import confirm from '@/components/confirm'

import { required, between } from 'vuelidate/lib/validators'
// import myBtns from '@/components/c_s_btns'
// import iconGroup from '@/components/iconGroup'
export default {
  components: { confirm },
  props: {},
  data () {
    return {
      color: '',
      file: [],
      deleteFileList: [],
      skLoading: true,
      showText: '',
      isLoading: false,
      isOpen: false,
      detailData: {
        product_name: '',
        product_shortcode: '',
        version: '',
        sequence: '',
      },
      version_arr: [],
      disabled: true,
      uuid: '',
      table: 'mrbase_sys_products',
      name: '',
      pers: '',
      valArr: ['a', 'b'],
    }
  },
  created () { },
  async mounted () {
    // 请求版本高级参照
    if (!this.$store.state.iconstatus) {
      this.disabled = false
    }
    await this.national('mrbase_sys_products')
    // const module_data = await getBusinessList('version')
    // this.version_arr = module_data.data
    // 有uuid传过来 就是修改 没有就是新增，
    const name = this.$store.getters.subPage_name
    const uuid = this.$route.params.uuid || this.$store.state.uuid

    this.uuid = uuid
    if (this.uuid) {
      const res = await get_detail({ uuid: this.uuid })
      if (res.code == 200) {
        this.detailData = res.data
      }
    }
    this.skLoading = false
  },
  methods: {
    deleteicon (v) {
      if (v.uuid) this.deleteFileList.push(v)
    },
    changeimgSrc (v) {
      this.file = v
    },
    handleReturn () {
      this.$router.go(-1)
    },
    handleEdit () {
      this.disabled = !this.disabled
    },
    onCancel () {
      this.isOpen = false
    },
    onConfirm () {
      this.$router.go(-1)
    },
    async cancel () {
      if (this.uuid) {
        const res = await get_detail({ uuid: this.uuid })
        if (res.code == 200) {
          this.detailData = res.data
        }
        this.disabled = !this.disabled
      }
      else {
        this.$myConfirm({
          content: this.$t('message_Confirm_the_cancellation_of_the_edit'),
        })
          .then(() => {
            this.$router.go(-1)
          })
          .catch(() => { })
      }
      // this.isOpen = true
      // this.showText = '放弃修改'
    },
    async success () {
      if (this.uuid) {
        await this.$uploadFiles(this.file, {
          module_uuid:'module',
          function_uuid: this.$store.state.menuFunctionUuid,
        }).then((res) => {
          let urllist = ''
          if (typeof res == 'object' && res != undefined && res.code == 200) {
            this.detailData.product_icon = res.uuid
            urllist = res.uuid
          }
          get_update({
            product_name: this.detailData.product_name,
            product_shortcode: this.detailData.product_shortcode,
            version: this.detailData.version,
            sequence: this.detailData.sequence,
            uuid: this.uuid,
            product_icon: this.detailData.product_icon,
          }).then(async (update) => {
            if (update.code == 200) {
              this.deleteFileList.forEach((item) => {
                this.$deleteFile(item.uuid)
              })
              this.file = []
              this.deleteFileList = []
              this.$Message({
                text: this.$t('message_The_operation_was_successful'),
              })
              const res = await get_detail({ uuid: this.uuid })
              if (res.code == 200) {
                this.detailData = res.data
              }
              // this.$router.go(-1)
              this.disabled = !this.disabled
            } else {
              this.$deleteFile(urllist)
              // this.$router.go(-1)
              this.disabled = !this.disabled
            }
          })
        })
      }
    },
  },
  computed: {},
  watch: {},
  validations: {
    detailData: {
      product_name: {
        required,
      },
      product_shortcode: {
        required,
      },
      sequence: {
        required,
        between: between(0, 999),
      },
    },
  },
}
</script>

<style scoped></style>
